module.exports = __webpack_public_path__ + "static/media/04.c53a62c1.JPG";